(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ActivityHistoryDetailController', ActivityHistoryDetailController);

    ActivityHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ActivityHistory', 'Contract', 'Shipment', 'Invoice', 'Lot'];

    function ActivityHistoryDetailController($scope, $rootScope, $stateParams, previousState, entity, ActivityHistory, Contract, Shipment, Invoice, Lot) {
        var vm = this;

        vm.activityHistory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:activityHistoryUpdate', function(event, result) {
            vm.activityHistory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
